export default __webpack_public_path__ + "static/media/face4.5d3b2882.svg";